export default ({ redirect, store, app }, inject) => {
  inject('oneplaceHelper', {
    goLogin: async () => {
      // Make sure to clear session / cookie
      try {
        console.log('goLogin was called, signing out')
        await store.$api.signOut()
        store.dispatch('auth/logout')
      } catch (err) {} // 403 if already sign out; Do nothing

      // redirect('https://www.google.com')
      const apiAuthenticationEndpoint = `${process.env.API_BASE_URL}/Authentication/RegisterReturn`
      // OnePlace side params. Used for OnePlace sign in process but not SkillsVue api callback
      const returnUrl = process.env.API_BASE_URL
      const encodeTokenUrl = encodeURIComponent(
        `${apiAuthenticationEndpoint}?ReturnUrl=${returnUrl}`
      )
      const opSignInUrl = `${process.env.ONEPLACE_SIGN_IN_URL}?tokenUrl=${encodeTokenUrl}`
      window.location.href = opSignInUrl
    },
    // variant = { 'ERROR', 'COUNTRIES', 'COUNTRY_CODE', 'HELP', 'NO_SUBSCRIPTION', 'TERMS' }
    initNavbar: (variant) => {
      const el = document.getElementById('ChromeHeader')
      const router = store.$router
      const i18n = app.i18n

      if (!!window.$OP && typeof window.$OP.loadCommonChrome === 'function') {
        const countryCode = app.$routeParams.getCountryCode(router)
        const menuItems = getMenuItems(variant, router, countryCode, i18n)

        let caption = menuItems.length > 0 ? '' : null // empty string to enable caption feature. Will set it in .done() to enable isDropdown class feature so9sad
        let captionActions = null

        if (menuItems.length === 1) {
          caption = menuItems[0].name
          captionActions = menuItems[0].action
        } else if (menuItems.length > 1) {
          // !!! caption need to set in .done() for drop down...
          captionActions = menuItems
        }

        const options = {
          captionRightAlignment: true,
          caption: caption,
          captionActions: captionActions,
          header: {
            appIconAction: () => {
              router.push({ path: '/' })
            }
          },
          shoppingCart: {
            enabled: true,
            width: undefined,
            height: undefined
            // Cannot use onClick. It is click-able when refreshCartIndicator(n > 1), and it will add have span icon on top of it
          }
        }
        window.$OP.loadCommonChrome(options).done((obj) => {
          if (menuItems.length > 1) {
            obj.setCaption(i18n.t('nav.quick-links'))
          }

          const regionIcon = getRegionIcon(store, countryCode)
          setRegionIcon(
            router,
            document.getElementById('shoppingcart'),
            regionIcon
          )

          // Remove the previous OnePlace header
          if (el) {
            el.parentElement.removeChild(el)
          }
        })
      } else {
        console.log('cannot init oneplace ERROR')
        // TODO: call rollbar?!
      }
    }
  })
}

function getMenuItemHelp(router, i18n) {
  return {
    name: i18n.t('nav.help'),
    action: () => {
      router.push({ path: '/help' })
    }
  }
}

function getMenuItemSelectCountry(router, i18n) {
  return {
    name: i18n.t('nav.select-country'),
    action: () => {
      router.push({ path: '/countries' })
    }
  }
}

// variant = { 'ERROR', 'COUNTRIES', 'COUNTRY_CODE', 'COUNTRY_CODE_SURVEY', 'HELP', 'TERMS', 'NO_SUBSCRIPTION' }
function getMenuItems(variant, router, countryCode, i18n) {
  let items = []

  switch (variant) {
    case 'NO_SUBSCRIPTION':
      items = []
      break
    case 'COUNTRIES':
      items = []
      break
    case 'COUNTRY_CODE':
      items = [
        getMenuItemHelp(router, i18n),
        getMenuItemSelectCountry(router, i18n)
      ]
      break
    case 'COUNTRY_CODE_SURVEY':
      items = [
        getMenuItemHelp(router, i18n),
        getMenuItemSelectCountry(router, i18n)
      ]
      break
    case 'HELP':
    case 'TERMS':
    default:
      items = [getMenuItemSelectCountry(router, i18n)]
  }

  return items
}

function isRegionValid(store, countryCode) {
  const subs = store.getters['auth/getAllowedSurveys']
  const currentRegion = subs.find((s) => s.country.slug === countryCode)
  return typeof currentRegion !== 'undefined'
}

function getRegionIcon(store, countryCode) {
  return isRegionValid(store, countryCode)
    ? require('@/assets/region-icons/' + `${countryCode}.svg`)
    : null
}

function setRegionIcon(router, elem, regionIcon) {
  if (regionIcon) {
    elem.style.background = `url(${regionIcon})`
    elem.style.backgroundRepeat = 'no-repeat'
    elem.style.padding = '1px 18px'
    elem.onclick = () => {
      router.push('/') // back to country selection page
    }
  } else {
    elem.style.display = 'none'
  }
}
